import { render, staticRenderFns } from "./InterviewSuccessMessage.vue?vue&type=template&id=08bd2f70&"
import script from "./InterviewSuccessMessage.vue?vue&type=script&lang=ts&"
export * from "./InterviewSuccessMessage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports